import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-actions-benefits-categories',
  templateUrl: './actions-benefits-categories.component.html',
  styleUrls: ['./actions-benefits-categories.component.scss']
})
export class ActionsBenefitsCategoriesComponent implements OnInit {
  @Input() benefitData;
  benefitForm: FormGroup;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.benefitForm = this.fb.group({
      title: [(this.benefitData ? this.benefitData.title : null), Validators.required],
      order: [(this.benefitData ? this.benefitData.order : null), [Validators.required, Validators.min(0)]],
      visibleFilter: [(this.benefitData ? this.benefitData.visibleFilter : 1), [Validators.required, Validators.min(0)]],
      visibleCarousel: [(this.benefitData ? this.benefitData.visibleCarousel : 1), [Validators.required, Validators.min(0)]],
      benefitsItems: [null]
    });
  }

  isValid(): void {
    let toSendData = this.benefitForm.value;
    if (this.benefitData) {
      toSendData.id = this.benefitData.id;
    }
    this.activeModal.close(toSendData);
  }
}
